import io from "socket.io-client";
import { SOCKET_URL } from "../constants/url";

export const Socket_URL = SOCKET_URL; // sandbox

export const socket = io(SOCKET_URL, {
  autoConnect: false,
});
